(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ionix-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    const form = select.closest('form.lmla-localization-form');
    if (!form || select.matches(':disabled') || document.body.dataset.localPreview === 'true') return;
    if (select.name === 'country_code') {
      const language = form.querySelector('[name="language_code"]');
      if (language) language.disabled = true;
    }
    form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();
})();
